@if (description()) {
    <span class="ap-input__description" data-testid="description" [attr.id]="uniqueId + '-description'">
        {{ description() }}
    </span>
}

<ng-content select="ap-context-explanation"></ng-content>

@if (helpTextPosition() === HelpTextPosition.ABOVE && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement; context: { above: true }"></ng-container>
}

<div class="ap-input__container">
    <label class="ap-input__wrapper" data-testid="wrapper">
        <span class="ap-input__label" data-testid="label">{{ label() }}</span>
        <input
            #input
            class="ap-input__input"
            data-testid="input"
            [disabled]="isDisabled ? isDisabled : null"
            [attr.inputmode]="inputmode()"
            [attr.type]="type()"
            [attr.maxlength]="maxlength() ? maxlength() : null"
            [attr.aria-required]="isRequired ? isRequired : null"
            [attr.aria-describedby]="ariaDescribedBy"
            [attr.aria-invalid]="control ? control.invalid : null"
            [attr.value]="value"
            [(ngModel)]="value"
            (input)="onInputChange($event)"
            (blur)="onBlur()"
            autocomplete="off"
        />
        @for (stripe of stripes; track $index; let i = $index) {
            <div
                [class]="'ap-activation-code__underline ap-activation-code__underline--' + stripe"
                [class.ap-activation-code__underline--caret]="i === value?.length"
            ></div>
        }
    </label>
</div>

@if (helpTextPosition() === HelpTextPosition.BELOW && helpText()) {
    <ng-container *ngTemplateOutlet="helpTextElement"></ng-container>
}

@if (control) {
    <ap-form-errors
        data-testid="errors"
        [control]="control"
        [messages]="messages()"
        [content]="content"
        [attr.id]="uniqueId + '-errors'"
    ></ap-form-errors>
}

<ng-template #helpTextElement let-above="above">
    <div
        class="ap-input__help-text {{ above ? 'ap-input__help-text--above' : 'ap-input__help-text--below' }}"
        data-testid="help-text"
        [attr.id]="uniqueId + '-help-text'"
        [innerHTML]="helpText()"
    ></div>
</ng-template>
